<template>
  <baseEdit />
</template>

<script>
  import baseEdit from './baseEdit';

  export default {
    name: 'collectBillDetails',
    components: {
      baseEdit,
    },
  };
</script>
